import React from "react";
import { useTheme, Typography, Box, lighten } from "@mui/material";
import { CopyToClipboardButton } from "@lp/lp-ui";

interface UserPasswordDisplayProps {
    userName: string,
    password: string
}

const UserPasswordDisplay: React.FC<UserPasswordDisplayProps> = ({ userName, password }: UserPasswordDisplayProps) => {
    const theme = useTheme();

    return (
        <Box minWidth={300}>
            <Typography marginBottom={1}>
                The password for the user "{userName}" is:
            </Typography>
            <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center">
                <Box component="span" pt={0.5} pb={0.5} pl={1} pr={1} border="solid 1px" borderRadius={1} bgcolor={lighten(theme.palette.primary.light, 0.5)}>
                    {password}
                </Box>
                <CopyToClipboardButton text={password} size='small' />
            </Box>
            <Typography marginTop={1}>
                This is the last time this password will be shown.
            </Typography>
        </Box>
    );
}

export default UserPasswordDisplay;
